module.exports = __webpack_public_path__ + "img/مانغو.bc2dbc6d.png";